import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/languages'
const baseFunctions = GetBaseServiceFunctions(BaseRoute)

const API = {
  ...baseFunctions,
  GetAll,
  GetLanguageLookupConfig,
}

function GetAll(params = {}) {
  return ApiRequest.get(`${BaseRoute}`, { params })
}

function GetLanguageLookupConfig(params = {}) {
  return ApiRequest.get(`${BaseRoute}/lookupConfig`, { params })
}

export default API
